import React, { useTransition, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import logo from '../../../../assets/img/conneqt_logo.png';
import styles from './welcomeScreen.module.scss';
import { OnBoardingMobile } from '../smart/onBoardingMobile.smart';
import { ConneqtLogo } from '../../../../components/logo/logo';

export const SplashScreen = () => {
  const { t } = useTranslation();
  const [isPending, startTransition] = useTransition();
  const [showSplashScreen, setShowSplashScreen] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      startTransition(() => {
        setShowSplashScreen(false);
      });
    }, 1000);
  }, [showSplashScreen]);

  return (
    <>
      {!showSplashScreen ? (
        <OnBoardingMobile />
      ) : (
        <div className={styles.container}>
          <ConneqtLogo />
          <div className={styles.message}>
            <span>{t('SPLASH_MESSAGE')}</span>
          </div>
        </div>
      )}
    </>
  );
};
